// extracted by mini-css-extract-plugin
export default {"container":"ThemeConfirmDialog_container__uveLw","buttonsContainer":"ThemeConfirmDialog_buttonsContainer__+Yeko"};